import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import umami from './umami';

// Sends one pageview per SPA route change.
//
// Time on each module is not derived from the gap between pageviews — the
// tracker measures visible engaged time and emits it as a `pageleave` event
// when the view ends (see umami.js). umami.pageview() closes the previous
// view before opening the new one, so navigating away is what records the
// time for the module being left.
const RouteTracker = ({ profileReady }) => {
  const location = useLocation();

  useEffect(() => {
    if (!profileReady) return;
    umami.pageview(location.pathname);
  }, [location.pathname, profileReady]);

  return null;
};

export default RouteTracker;
